import React, { useState, useEffect, useRef } from 'react';
import './Projects.css';
import ProjectsFilter from './ProjectsFilter/ProjectsFilter';

const Projects = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '0px 0px -150px 0px', threshold: 0 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section id="projects" ref={sectionRef} className={isVisible ? 'scrolled-into-view' : ''}>
      <div className="projectsBackdrop" aria-hidden="true">
        <div className="projectsGrid" />
      </div>

      <div className="projectsWrapper">
        <div className="projectsText">
          <h2>
            <span className="projectTextHeading projectTextHeadingFancy" style={{ transitionDelay: '0s' }}>
              Featured
            </span>
            <br />
            <span className="projectTextHeading" style={{ transitionDelay: '0.2s' }}>
              Work
            </span>
          </h2>
          <p className="white">
            <span className="projectTextWord" style={{ transitionDelay: '0.6s' }}>
              Here{' '}
            </span>
            <span className="projectTextWord" style={{ transitionDelay: '0.65s' }}>
              are{' '}
            </span>
            <span className="projectTextWord" style={{ transitionDelay: '0.7s' }}>
              some{' '}
            </span>
            <span className="projectTextWord" style={{ transitionDelay: '0.75s' }}>
              of{' '}
            </span>
            <span className="projectTextWord" style={{ transitionDelay: '0.8s' }}>
              my{' '}
            </span>
            <span className="projectTextWord" style={{ transitionDelay: '0.85s' }}>
              favorite{' '}
            </span>
            <span className="projectTextWord" style={{ transitionDelay: '0.9s' }}>
              <span className="bold">recent </span>
            </span>
            <span className="projectTextWord" style={{ transitionDelay: '0.95s' }}>
              <span className="bold">projects</span>
            </span>
          </p>
        </div>
        <ProjectsFilter />
      </div>
    </section>
  );
};

export default Projects;
